/**
 * Event detail for value-changed events dispatched by O2dTextareaElement.
 */
export interface ValueChangedDetail {
    value: string;
}

/**
 * Event name constant for type-safe event listener registration.
 *
 * @example
 * ```typescript
 * element.addEventListener(VALUE_CHANGED_EVENT, (e: CustomEvent<ValueChangedDetail>) => {
 *   console.log(e.detail.value);
 * });
 * ```
 */
export const VALUE_CHANGED_EVENT = 'value-changed' as const;
